<template>
  <div>
    <div class="message-container">
      <div class="message-scroll">
        <div class="message-detail" id="containerChat">
          <div class="message-box" :key="key" v-for="(chat, key) in chats">
            <v-card
              color="#FCFCFC"
              elevation="0"
              class="pa-3 container-message"
              v-if="chat.type==='message'"
            >
              <div class="chat-avatar">
                <v-avatar :size="30" justify="center">
                  <img :src="chat.userImg" />
                </v-avatar>
              </div>
              <div class="box-message">
                <span :class="allTeacherIds.indexOf(chat.userID) > -1 ? 'chat-time teacher':'chat-time'">
                  {{chat.timeStamp | moment("HH:mm:ss")}} 
                </span>
              <span
                :class="allTeacherIds.indexOf(chat.userID) > -1 ? 'chat-name teacher':'chat-name'"
              >{{chat.displayName}}</span>
              <span class="chat-message" v-html="chat.msg"></span>
              </div>
            </v-card>
            <v-card
              color="#FCFCFC"
              elevation="0"
              class="pa-3 container-message"
              v-if="chat.type!=='message'"
            >
              <div class="chat-avatar align-top">
                <v-avatar :size="30" justify="center">
                  <img :src="chat.userImg" />
                </v-avatar>
              </div>
              <div
                :class="allTeacherIds.indexOf(chat.userID) > -1 ? 'chat-name full-width teacher':'chat-name full-width'"
              >
                <span :class="allTeacherIds.indexOf(chat.userID) > -1 ? 'chat-time teacher':'chat-time'">
                  {{chat.timeStamp | moment("hh:mm:ss")}} 
                </span>
                {{chat.displayName}}
                <br />
                <div
                  class="question-container"
                  v-if="chat.type=='question'"
                >The instructor has sent you a question.</div>
                <div
                  class="question-container"
                  v-if="chat.type=='checkName'"
                >The instructor has checked the name #{{chat.term}}</div>
                <div
                  class="question-container"
                  v-if="chat.type=='endLive'"
                >The live has ended</div>
              </div>
            </v-card>
            <!-- <v-card
              color="#FCFCFC"
              elevation="0"
              class="pa-3 container-message"
              v-if="chat.type!=='message'"
            >
              <div class="chat-avatar">
                <v-avatar :size="30" justify="center">
                  <img :src="chat.userImg" />
                </v-avatar>
              </div>
              <div
                class="question-container"
                v-if="chat.type=='question'"
              >The instructor has sent you a question.</div>
              <div
                class="question-container"
                v-if="chat.type=='checkName'"
              >The instructor has checked the name #{{chat.term}}</div>
            </v-card>-->
          </div>
        </div>
        <!-- <div class="sender-message-container">
          <v-textarea
            placeholder="Say something..."
            rows="1"
            v-model="msg"
            @keydown.enter="sendChat"
          ></v-textarea>
          <div class="sender-container">
            <div class="message-counter">{{msg.length}}/200</div>
            <div class="message-sender">
              <v-icon @click="sendChat" size="20" class="icon-sender">fas fa-paper-plane</v-icon>
            </div>
          </div>
        </div>-->
        <senderChat :sendChat.sync="sendChat" />
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
// import { checkDevice } from "@/helper/checkDevice";
import senderChat from "@/components/live/senderChat";
import firebase from "@/plugins/firebase";
var database = firebase.database();
// let deviceDetail = checkDevice();
import { mapState } from "vuex";

import $ from "jquery";
export default {
  name: "login",
  components: {
    senderChat,
  },
  props: {
    courseId: {
      type: String,
    },
    liveId: {
      type: String,
    },
    chatRoom: {
      type: String,
    },
  },
  computed: mapState(["hisLiveStreamID"]),
  watch: {
    chatRoom(value) {
      this.chats = [];
      this.initChatRoom();
    },
    hisLiveStreamID(value) {
      if (value && value !== "" && !this.successLoadLiveDetail) {
        this.successLoadLiveDetail = true;
        // connect with onlineUser
        const rawId = this.$route.params.id.split("-");
        // const courseId = rawId[0];
        const liveId = `live_${rawId[1]}`;
        this.onlineUserRef = database.ref("/onlineUser").child(liveId);

        this.allTeacherIds = [
          this.liveDetail().created_by._id,
          ...this.liveDetail().teacher.map((t) => t._id),
        ];
        // connect with local device to check internet connection
        this.connectedRef = database.ref(".info/connected");
        this.connectedRef.on("value", (snap) => {
          if (snap.val() === true) {
            // We're connected (or reconnected)! Do anything here that should happen only if online (or on reconnect)
            this.con = this.onlineUserRef.push();

            // When I disconnect, remove this device
            this.con.onDisconnect().remove();

            // Add this device to my connections list
            // this value could contain info about the device or a timestamp too
            this.con.set({
              displayName: Vue.prototype.$userInfo.displayName,
              hisLiveStreamID: value,
              id: Vue.prototype.$userInfo._id,
              server: "TULA",
              token: this.$cookies.get("user_token"),

              platform: "Web app",
              device: this.$platformDetect.ua,
              osversion: `${this.$platformDetect.os}`,
              browser: `${this.$browserDetect.meta.name} ${this.$browserDetect.meta.version}`
            });
          }
        });
      }
    },
  },
  beforeDestroy(){
    this.con.remove();
  },
  data: () => ({
    chats: [],
    msg: "",
    userImg: null,
    userID: null,
    displayName: null,
    ownerID: null,
    liveStreamDetail: null,
    coursesRef: null,
    onlineUserRef: null,
    connectedRef: null,
    con: null,
    answerdEventMessage: [],
    liveDetail() {
      return this.$store.getters.liveDetail;
    },
    successLoadLiveDetail: false,
    allTeacherIds: [],
    onReturnObjectForOff: undefined,
    // width: 0
  }),
  async mounted() {
    await this.initChatRoom();
    await this.initLiveMessageStatus();
    await this.onQuizAndNameCheck();
    this.ownerID = Vue.prototype.$userInfo._id;
    this.userImg = Vue.prototype.$userInfo.image;
    this.displayName = Vue.prototype.$userInfo.displayName;
  },
  methods: {
    async onQuizAndNameCheck() {
      const {courseId,liveId} = this.commonDetail();
      const coursesRef = database
        .ref("/courses")
        .child(`/${courseId}`)
        .child(`/${liveId}`);
      coursesRef.on("child_added", async (snapshot) => {
        let temp = snapshot.val();
        temp.messageKey = snapshot.key
        let foundMessage = await this.findUsedMessage(snapshot.key)
        if(!foundMessage){
          if (temp.type === "checkName") {
            this.$store.commit("updateLiveNotification", temp);
          } else if (temp.type === "endLive") {
            this.$store.commit("updateEndLiveNotification", temp);
          } else if (temp.type === "question") {
            this.$store.commit("updateLiveQuestion", {
              delay: temp.delay,
              displayName: temp.displayName,
              questionID: temp.questionID,
              timeRequest: temp.timeRequest,
              timeStamp: temp.timeRequest,
              type: temp.type,
              userID: temp.userID,
              userImg: temp.userImg,
              messageKey: temp.messageKey
            });
          }
        }
      });
    },
    async findUsedMessage (key) {
      let foundIndex = this.answerdEventMessage.findIndex(message => message == key)
      return foundIndex > -1 ? true : false
    },
    async initLiveMessageStatus() {
      const {courseId,liveId} = this.commonDetail();
      const answerdEventMessageFirebase = database
        .ref("/answerdEventMessage")
        .child(`/user_${Vue.prototype.$userInfo._id}`)
        .child(`/${liveId}`);
      this.answerdEventMessage = []
      this.answerdEventMessage = await answerdEventMessageFirebase.once('value')
      .then((snapshot) => {
        let data = snapshot.val()
        if(data) {
          return Object.keys(data)
        }
        return []
      })
    },
    commonDetail() {
      const rawId = this.$route.params.id.split("-");
      const courseId = rawId[0];
      const liveId = `live_${rawId[1]}`;
      return {
        courseId,
        liveId,
      };
    },
    async initChatRoom() {
      const {courseId,liveId} = this.commonDetail();
      const searchPattern = new RegExp(
        "(http|ftp|https)://([\\w_-]+(?:(?:\\.[\\w_-]+)+))([\\w.,@?^=%&:/~+#-]*[\\w@?^=%&/~+#-])?",
        "g"
      );
      const replacePattern = '<a href="$&" target="_blank">$&</a>';
      const childAddedCallback = (snapshot) => {
        const valForMessage = snapshot.val();
        if (valForMessage.msg) {
          valForMessage.msg = valForMessage.msg.replace(
            searchPattern,
            replacePattern
          );
        }
        if (valForMessage.type) {
          this.chats.push(valForMessage);
        }

        setTimeout(function () {
          $("#containerChat").scrollTop($("#containerChat")[0].scrollHeight);
        }, 100);
      };

      let roomName = null;
      if (this.chatRoom) {
        roomName = `/room_${this.chatRoom}`;
      }

      if (this.onReturnObjectForOff) {
        this.coursesRef.off("child_added", this.onReturnObjectForOff);
      }

      if (roomName) {
        this.coursesRef = database
          .ref("/courses")
          .child(`/${courseId}`)
          .child(`/${liveId}`)
          .child(roomName);
          // /courses/5f5b242ea0e9df6a8ca62d62/live_6045edaed00766258865488f/room_6045ee845ad73d030c5831b9
      } else {
        this.coursesRef = database
          .ref("/courses")
          .child(`/${courseId}`)
          .child(`/${liveId}`);
      }
      this.onReturnObjectForOff = this.coursesRef.on("child_added", childAddedCallback);
    },
    async sendChat(data) {
      if (data.length > 0) {
        let chatPayload = {
          msg: data,
          userID: this.ownerID,
          userImg: this.userImg,
          timeStamp: firebase.database.ServerValue.TIMESTAMP,
          type: "message",
          isTeacher: this.allTeacherIds.indexOf(this.ownerID) > -1,
          displayName: this.displayName,
          platform: "Web app",
          device: this.$platformDetect.ua,
          osversion: `${this.$platformDetect.os}`,
          browser: `${this.$browserDetect.meta.name} ${this.$browserDetect.meta.version}`,
        };
        await this.coursesRef.push(chatPayload);
        // this.msg = "";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.message-container {
  position: relative;
  height: 77vh;
  border-style: unset !important;
}
.message-scroll {
  height: 80vh;
  overflow: hidden;
}
.message-detail {
  background-color: #fcfcfc;
  height: 77%;
  overflow-y: scroll;
  padding-top: 15px;
  border: 1px solid #f2f2f2;
  border-bottom-width: 0px;
}
.message-detail:hover {
  /* background-color: ghostwhite; */
  /* height: 470px; */
  /* margin-bottom: 10px; */
  /* overflow-y: scroll; */
  /* overflow: hidden; */
}
.chat-avatar {
  // padding: 12px;
  padding-right: 16px;
  // align-self: center;
  // width: 30px;
  // display: flex;
}
.chat-message {
  // padding: 10px;
  // padding: 12px 12px 12px 0px;
  // display: inline-table;
  font-size: 12px;
  font-weight: 500;
  // max-width: 150px;
  /* width: 50px; */
  // width: 100%;
}
.question-container {
  // padding: 10px;
  // padding: 12px 12px 12px 0px;
  // display: inline-table;
  color: #4a4a4a;
  margin-top: 10px;
  font-size: 12px;
  font-weight: 500;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  padding: 16px;
  // max-width: 150px;
  /* width: 50px; */
  max-width: 100%;
}
.container-message {
  display: flex;
}
.chat-name {
  // width: 90px;
  // width: 130px;
  // align-self: center;
  margin-right: 10px;
  font-weight: bold;
  color: #848484;
  font-size: 12px;
  font-weight: 500;
  &.teacher {
    color: #e77b9f;
  }
}
.chat-time {
  // font-weight: bold;
  // width: 80px;
  // text-align: right;
  // font-size: 16px;
  margin-right: 10px;
  font-weight: normal;
  color: #848484;
  font-size: 12px !important;
  // font-weight: 500;
  &.teacher {
    color: #e77b9f;
  }
}
.owner-message {
  color: white;
}
/* .send-message-container{

} */
.send-message-container {
  /* position: relative; */
  /* height: 200px; */
  /* border: 3px solid red; */
  /* position: absolute; */
  /* width: 100%; */
  /* bottom: 10px; */
  position: absolute;
  bottom: 10px;
  width: 92%;
}

.send-message-input {
  /* position: absolute;
  bottom: 10px; */
  /* border: 3px solid #8AC007; */
  display: inline-block;
}
.send-message-btn {
  float: right;
  /* display: inline-block; */
  width: 90px;
}
.message-box {
  // padding-left: 10px;
  // padding-right: 10px;
  // margin-bottom: 10px;
}
.v-card:not(.v-sheet--tile):not(.v-card--shaped) {
  border-radius: 8px;
}
.send-container {
  padding-left: 10px;
  padding-right: 10px;
}

.container-left {
  width: 30px;
  float: left;
}

.container-right {
  width: 60;
  float: right;
}

.container-center {
  width: calc(100% - 60px - 60px);
  margin: 0 auto;
}

.send-container-right {
  width: 80px !important;
  float: right;
  margin-right: 20px;
  padding-top: 18px;
  // padding: 10px 0px 0px 0px;
}
.send-container-left {
  width: calc(95% - 80px);
  // margin:0 auto;
  float: left;
}
.sender-input {
  // padding-right: 5px;
  // padding-left: 10px;
  // padding-top: 10px;
  border-radius: 0px !important;
}
.sender-btn {
  border-radius: 0px;
  background-color: #77cae7 !important;
}
.v-text-field--filled > .v-input__control > .v-input__slot,
.v-text-field--full-width > .v-input__control > .v-input__slot,
.v-text-field--outlined > .v-input__control > .v-input__slot {
  -webkit-box-align: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
  min-height: 50px;
}
.full-width {
  // width: 100%;
  width: unset;
  max-width: 100%;
}
.align-top {
  align-self: flex-start;
}
</style>
<style >
.sender-input > .v-text-field.v-text-field--enclosed .v-text-field__details,
.v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)
  > .v-input__control
  > .v-input__slot {
  /* padding: 0 12px; */
  min-height: 50px;
}
.chat-message {
  /* align-self: center; */
  color: #000000;
  font-size: 12px;
  font-weight: 400px;
}
.sender-message-container {
  color: #ffffff;
  padding: 20px;
  border: 1px solid #f2f2f2;
}
.message-counter {
  /* float: left; */
  text-align: left;
  width: 50%;
  color: #9b9b9b;
  font-size: 11px;
  font-weight: 400;
  align-self: center;
}
.message-sender {
  /* float: right; */
  text-align: right;
  width: 50%;
}
.icon-sender {
  align-items: center !important;
  display: inline-flex !important;
  font-feature-settings: "liga" !important;
  font-size: 24px !important;
  justify-content: center !important;
  letter-spacing: normal !important;
  line-height: 1 !important;
  position: relative !important;
  text-indent: 0 !important;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), visibility 0s !important;
  vertical-align: middle !important;
  -webkit-user-select: none !important;
  -moz-user-select: none !important;
  -ms-user-select: none !important;
  user-select: none !important;

  background: unset !important;
  color: #009bde !important;
}
.v-icon.v-icon.v-icon--link {
  font-size: 20px !important;
}
.sender-container {
  display: flex;
}
.question-message {
}
.box-message {
  font-size: 1.125rem!important;
}
</style>
